import { render, staticRenderFns } from "./LockedGlyph.vue?vue&type=template&id=c3ccaa7a&lang=html&"
import script from "./LockedGlyph.vue?vue&type=script&lang=js&"
export * from "./LockedGlyph.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports